export enum FetalPresentation {
	Cephalic = "0",
	Pelvic = "1",
	Cormic = "2",
}
